import React from 'react';
import { Box, Text, HStack } from '@chakra-ui/react';

export function CustomToggleSwitch({ leftLabel, rightLabel, isChecked, onChange, size = "md" }) {
    const sizeStyles = {
        sm: {
            px: 2,
            py: 1,
            fontSize: "xs"
        },
        md: {
            px: 4,
            py: 2,
            fontSize: "sm"
        }
    };

    const styles = sizeStyles[size];

    return (
        <HStack
            spacing={0}
            bg="gray.100"
            borderRadius="md"
            p="2px"
            borderWidth="1px"
            borderColor="gray.200"
            cursor="pointer"
            transition="all 0.2s"
        >
            <Box
                px={styles.px}
                py={styles.py}
                bg={!isChecked ? "white" : "transparent"}
                borderRadius="md"
                onClick={() => onChange(false)}
                cursor="pointer"
                transition="all 0.2s"
                boxShadow={!isChecked ? "sm" : "none"}
            >
                <Text
                    fontSize={styles.fontSize}
                    fontWeight={!isChecked ? "600" : "500"}
                    color={!isChecked ? "gray.700" : "gray.500"}
                >
                    {leftLabel}
                </Text>
            </Box>
            <Box
                px={styles.px}
                py={styles.py}
                bg={isChecked ? "white" : "transparent"}
                borderRadius="md"
                onClick={() => onChange(true)}
                cursor="pointer"
                transition="all 0.2s"
                boxShadow={isChecked ? "sm" : "none"}
            >
                <Text
                    fontSize={styles.fontSize}
                    fontWeight={isChecked ? "600" : "500"}
                    color={isChecked ? "gray.700" : "gray.500"}
                >
                    {rightLabel}
                </Text>
            </Box>
        </HStack>
    );
}

